import { useQuery } from "@apollo/client";
import { GET_USER } from "api/query";
import type { GetUserQuery, GetUserQueryVariables } from "graphql/generated";

/**
 * @param timeout ms to wait for `GET_USER`. Defaults to the timeout of the
 * client.
 */
export const useUser = ({ timeout }: { timeout?: number } = {}) => {
  const { data, loading, error, refetch } = useQuery<
    GetUserQuery,
    GetUserQueryVariables
  >(GET_USER, { context: { timeout } });

  const user = data?.getUser;
  const hasMfa = (user?.mfaMethods?.length ?? 0) > 0;

  return { user, hasMfa, loading, error, refetch };
};
